'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('../../node_modules/angular-material/angular-material.min.css');

var _angularAnimate = require('angular-animate');

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularAria = require('angular-aria');

var _angularAria2 = _interopRequireDefault(_angularAria);

require('../../bower_components/angular-messages/angular-messages.min');

require('angular-resource');

require('angular-material');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _components = require('./components/components');

var _components2 = _interopRequireDefault(_components);

var _app = require('./app.component');

var _app2 = _interopRequireDefault(_app);

var _common = require('./common/');

var _common2 = _interopRequireDefault(_common);

var _app3 = require('./app.config');

var _app4 = _interopRequireDefault(_app3);

require('normalize.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('app', [_angularUiRouter2.default, 'ngMaterial', 'ngResource', _components2.default, _common2.default]).component('app', _app2.default).config(_app4.default);


// WEBPACK FOOTER //
// ./client/app/app.js